module.exports = __webpack_public_path__ + "static/media/sort-alpha-up.01492b52.svg";